import React from 'react';
import { PageHeader as KitPageHeader } from '../../sectepe-ui/index';
import { Icon } from '../icons';
import { handbuchUrl } from '../../hilfe/handbuch';

export interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  /** Knoepfe rechts neben dem Titel. */
  actions?: React.ReactNode;
  /** Kleine Zeile ueber dem Titel (z. B. Prozessname). */
  eyebrow?: React.ReactNode;
  /** Unter Titel und Untertitel, z. B. die Schrittleiste. */
  children?: React.ReactNode;
  /**
   * Anker im Anwenderhandbuch (z. B. `rechnungen`). Ist HANDBUCH_URL
   * konfiguriert, steht rechts ein kleiner Hilfe-Link dorthin; sonst nichts.
   */
  hilfe?: string;
}

const HilfeLink: React.FC<{ href: string }> = ({ href }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="btn btn-ghost btn-sm"
    aria-label="Hilfe im Handbuch (öffnet in neuem Tab)"
    title="Hilfe im Handbuch öffnen"
  >
    <Icon name="info" size={14} />
  </a>
);

/**
 * Einheitlicher Seitenkopf — duenner Wrapper um `PageHeader` aus @sectepe/ui
 * (API der App bleibt; der Eyebrow wird als Breadcrumb-Zeile gerendert).
 */
export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions, eyebrow, children, hilfe }) => {
  const hilfeHref = hilfe ? handbuchUrl(hilfe) : null;
  const alleAktionen = hilfeHref ? (
    <>
      {actions}
      <HilfeLink href={hilfeHref} />
    </>
  ) : actions;
  return (
    <div className="ui-page-header">
      <KitPageHeader
        title={title}
        description={subtitle}
        actions={alleAktionen}
        breadcrumbs={eyebrow ? [eyebrow] : undefined}
        className={children ? 'sec-page-header--with-slot' : undefined}
      />
      {children}
    </div>
  );
};

export default PageHeader;
